import { render, staticRenderFns } from "./return_goods.vue?vue&type=template&id=459ad037&"
import script from "./return_goods.vue?vue&type=script&lang=js&"
export * from "./return_goods.vue?vue&type=script&lang=js&"
import style0 from "./return_goods.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports